import { registerDestructor } from '@ember/destroyable';
import Modifier from 'ember-modifier';

export default class CloseOnClickOutside extends Modifier {
  element = null;
  handleClose = null;
  selector = null;

  cleanup = () => {
    document.removeEventListener('click', this.onClickOutside);

    this.element = null;
    this.handleClose = null;
    this.selector = null;
  };

  modify = (element, [handler, selector]) => {
    this.element = element;

    this.handleClose = handler;
    this.selector = selector;

    document.addEventListener('click', this.onClickOutside);

    registerDestructor(this, this.cleanup);
  };

  onClickOutside = ({ target }) => {
    if (!this.element.contains(target) || target.classList.contains(this.selector)) {
      this.handleClose();
    }
  };
}
